import { Box } from '@mui/material'
import React from 'react'
import { ContractState, RevenueCalculatorButton } from '.'
import { CloudKeyModel } from 'src/Libs/installation-rights-management/models'
import { ExtensionState } from 'src/Libs/installation-extensions/types'

interface Props {
  allowRedirect: boolean
  cloudKey?: CloudKeyModel
  extensionState?: ExtensionState
}

/**
 * Footer content of the luox detail view. Allows to access a revenue calculator and displays the contract status.
 */
const FooterContent: React.FC<Props> = ({ allowRedirect, cloudKey, extensionState }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
      {allowRedirect && <RevenueCalculatorButton luoxEnergyCloudKey={cloudKey} />}
      <ContractState contractState={extensionState} />
    </Box>
  )
}

export default FooterContent
